import React from 'react';

import { Navbar, Section, WelcomeContainer } from 'Components';
import Footer from 'Components/Footer/Footer';

const Home = () => {
  return (
    <>
      <Navbar />
      <Section />
      <WelcomeContainer />
      <Footer />
    </>
  );
};

export default Home;
